<template>
  <ModalStructure @close="$emit('close')" :nopadding="true">
    <div slot="title">Blog Categories</div>
    <div slot="body">
      <div>
        <v-list-item
          v-for="category in blogCategories"
          :key="category.id"
          dense
        >
          <v-list-item-content>
            <v-list-item-title
              >{{ category.name }} (/{{ category.slug }})</v-list-item-title
            >
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="tryDeleteBlogCategory(category)" small>
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider></v-divider>
        <div style="width: 400px" class="pa-3">
          <v-text-field
            label="New Category"
            type="text"
            v-model="newCategoryName"
            @input="
              newCategorySlug = newCategoryName.toLowerCase().replace(' ', '-')
            "
            outlined
            dense
            autocomplete="off"
          />
          <v-text-field
            label="Category slug"
            type="text"
            v-model="newCategorySlug"
            outlined
            dense
            autocomplete="off"
            prefix="/blog/category/"
          />
          <div>
            <small
              >URL will be
              {{
                selectedProject.computedDomain +
                "/blog/category/" +
                newCategorySlug
              }}</small
            >
          </div>
          <v-btn
            small
            outlined
            dark
            color="primary"
            @click="tryCreateBlogCategory()"
            class="mt-2"
          >
            <v-icon small left>mdi-check</v-icon>Add
          </v-btn>
        </div>
      </div>
    </div>
  </ModalStructure>
</template>

<script>
import projectMixin from "./project-mixin";
import axios from "axios";
import { mapActions } from "vuex";

export default {
  mixins: [projectMixin],
  data() {
    return {
      newCategoryName: "",
      newCategorySlug: "",
    };
  },
  methods: {
    ...mapActions({
      getBlogPosts: "project/getBlogPosts",
    }),
    async tryCreateBlogCategory() {
      if (!this.newCategoryName) return;
      await axios.post("/Console/CreateBlogCategory", {
        projectId: this.selectedProject.id,
        name: this.newCategoryName,
        slug: this.newCategorySlug,
      });
      this.newCategoryName = "";
      this.newCategorySlug = "";
      this.getBlogCategories();
    },
    async tryDeleteBlogCategory(category) {
      if (
        confirm(
          "Delete category " +
            category.name +
            "? Deleting category removes all the posts under this"
        )
      ) {
        await axios.post("/Console/DeleteBlogCategory", {
          projectId: this.selectedProject.id,
          blogCategoryId: category.id,
        });
        this.getBlogCategories();
        this.getBlogPosts(this.selectedProject.id);
      }
    },
  },
  created() {
    this.getBlogCategories();
  },
};
</script>